import { Avatar, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { RadioChecked, RadioIcon } from 'Images';
import { useFormContext, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';

interface IRadioInput {
  name: string;
  options: { label: string; value: number | boolean | null }[];
  // Add a prop to pass the external value
  externalValue: string | number | boolean | null;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => void;
}

export const RadioInput = ({
  name,
  options,
  externalValue,
  onChange: externalOnChange,
}: IRadioInput) => {
  const { control } = useFormContext();
  // Use state to keep track of the current value
  const [internalValue, setInternalValue] = useState<
    string | number | boolean | null
  >(null);

  // Update the internal value when the external value changes
  useEffect(() => {
    setInternalValue(externalValue);
  }, [externalValue]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <RadioGroup
          sx={{
            gap: '20px',
          }}
          value={internalValue} // Use internal value instead of value from React Hook Form
          onChange={(event, value) => {
            setInternalValue(value);
            externalOnChange && externalOnChange(event, value);
            onChange(event);
          }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.label}
              aria-labelledby={option.label}
              sx={{ m: 0 }}
              componentsProps={{
                typography: {
                  variant: 'body3',
                  mr: '-6px',
                },
              }}
              value={option.value === null ? '' : option.value.toString()} // Convert null to empty string
              control={
                <Radio
                  icon={
                    <Avatar
                      alt=''
                      src={RadioIcon}
                      sx={{ width: '20px', height: '20px', ml: '-10px' }}
                    />
                  }
                  checkedIcon={
                    <Avatar
                      alt=''
                      src={RadioChecked}
                      sx={{ width: '20px', height: '20px', ml: '-10px' }}
                    />
                  }
                />
              }
              label={option.label}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
};
